import { useServiceStore } from "@/stores/serviceStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import { maliciousExtensions } from "@/types/maliciousExtensions";
import { inject } from "vue";

/** url 링크 유효성 검사 */
export const useValidateUrlLink = () => {
  const serviceStore = useServiceStore();

  const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

  // 확장자 검사 함수
  const isMaliciousFile = (url: string): boolean => {
    return maliciousExtensions.some((extension) => url.endsWith(extension));
  };

  const whiteListDomains = serviceStore.serviceInfo?.whiteListDomains ?? [];

  const isWhiteListDomain = (url: string) => {
    return whiteListDomains.some((domain) => url.startsWith(domain));
  };

  const validateUrlLink = (event: Event) => {
    const target = event.target as HTMLElement;

    // <a> 태그를 클릭했는지 확인
    if (target.tagName.toLowerCase() === "a") {
      const href = (target as HTMLAnchorElement).href;

      // 허용 도매인이 아니거나 악성 파일인 경우
      if (!isWhiteListDomain(href) || isMaliciousFile(href)) {
        event.preventDefault(); // 링크 차단
        showErrorModal(
          "링크 접근 불가",
          "이 링크는 보안상의 이유로 차단되었습니다."
        );
        return;
      }
    }
  };

  return { validateUrlLink };
};
